import { buildCartLineIdFromSelection } from './productVariants';
import { formatActiveMoney } from './currencyFormat';

/** @deprecated Prefer buildCartLineIdFromSelection — kept for older cart lines. */
export const buildCartLineId = (productId, size, color) =>
    `${productId}::${size || ''}::${color || ''}`;

export const buildCartLineIdFromOptions = (productId, selectedOptions) =>
    buildCartLineIdFromSelection(productId, selectedOptions);

export const getCartLineId = (item) => {
    if (item?.cartLineId) return item.cartLineId;
    const productId = item?.productId || item?._id || item?.id;
    if (Array.isArray(item?.selectedOptions) && item.selectedOptions.length) {
        return buildCartLineIdFromSelection(productId, item.selectedOptions);
    }
    return buildCartLineId(productId, item?.size, item?.color);
};

export const cartLinesMatch = (item, lineId) => getCartLineId(item) === lineId;

/**
 * Formats in the active store's currency. React components should prefer
 * `formatPrice` from usePublicSettings() so they re-render when a store's
 * currency setting changes mid-session; this stays for non-component callers.
 */
export const formatCartPrice = (amount) => formatActiveMoney(Number(amount) || 0);
